import { createTheme, ThemeProvider } from '@material-ui/core';
import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { createURL } from 'expo-linking';
import i18n from 'i18n-js';
import React, { lazy, Suspense } from 'react';
import { ActivityIndicator, StyleSheet, View } from 'react-native';
import { Provider } from 'react-redux';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import Loading from './component/Loading';
import store from './store';
import { RNCalendarLocaleSetter } from './component/RNCalendarLocaleSetter';

let persistor = persistStore(store);
const Stack = createNativeStackNavigator();

const BookingScreen = lazy(() => import('./screens/BookingScreen'));
const BookingRecordScreen = lazy(() => import('./screens/BookingRecordScreen'));
const BookingPostLoginScreen = lazy(() => import('./screens/BookingPostLoginScreen'));

const theme = createTheme({
  overrides: {
    MuiTab: {
      root: {
        minWidth: 0,
        '@media (min-width: 0px)': {
          minWidth: 0
        }
      }
    }
  }
});

export default function App() {

  const config = {
    screens: {
      BookingScreen: {
        path: 'pages/mbookingnew',
      },
      BookingRecordScreen: {
        path: 'pages/mbookingnew/record',
        stringify: {
          checkCode: (record) => typeof record === 'string' ? record : record.id,
        }
      },
      BookingPostLoginScreen: {
        path: 'pages/mbookingnew/post-login',
      }
    },
  };

  const linking = {
    prefixes: [createURL('/')],
    config,
  };

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={theme}>
          <RNCalendarLocaleSetter>
            <NavigationContainer linking={linking}>
              <Suspense fallback={<Loading />}>
                <Stack.Navigator screenOptions={{ headerShown: false }}>
                  <Stack.Screen name="BookingScreen" component={BookingScreen} options={{ title: i18n.t(['BOOKING', 'RESERVATION']) }} />
                  <Stack.Screen name="BookingRecordScreen" component={BookingRecordScreen} options={{ title: i18n.t(['BOOKING', 'DETAILS']) }} />
                  <Stack.Screen name="BookingPostLoginScreen" component={BookingPostLoginScreen} />
                </Stack.Navigator>
              </Suspense>
            </NavigationContainer>
          </RNCalendarLocaleSetter>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
  },
});
